<template>
  <div class="youqinglink">
    <div class="width1000 margintb">
      <div class="wrap clearFix">
        <div class="link_left">友情链接</div>
        <div class="link_right">

          <a :href="item.url"
             v-for="(item,index) in dataList.data"
             :key="index"
             target="_blank ">{{item.name}}</a>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      // dataList: {
      //   "id": 9,
      //   "type": "youqinglink",
      //   "sort": 9,
      //   "data": {
      //     "items": [
      //       { "name": "中央网", "url": "" },
      //       { "name": "国际在线", "url": "" },
      //       { "name": "中国新闻网", "url": "" }
      //     ]
      //   }
      // }
    }
  },
  props: ['dataList'],
  watch: {
    dataList (val) {

    }
  }
}
</script>
<style lang="less">
.youqinglink {
  margin-top: 30px;
  .wrap {
    .link_left {
      width: 88px;
      float: left;
      line-height: 30px;
    }
    .link_right {
      width: 890px;
      float: left;
      width: 890px;
      line-height: 30px;
      border-left: 1px solid #f5f5f5;
      padding-left: 20px;
      a {
        margin-right: 10px;
      }
      a:link,
      a:hover {
        color: #000;
      }
    }
  }
}
</style>
